export default __webpack_public_path__ + "static/media/pmdm.012d873c.svg";